import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { AxiosResponse } from 'axios';
import { TypePracticeData } from 'shell/models/type-practice';
import { memo } from 'react';
import { __PRACTICE_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { ItemVM } from 'shell/view-models/item';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { PmiSelect } from 'shell/components/shared/pmi-select';

interface ListTypePracticeProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
}

const ListTypePracticeComponent = ({
  disabled,
  required,
  onChange,
  value,
  error,
}: ListTypePracticeProps): React.ReactElement => {
  const [list] = useHttpFetch<HttpResponseList<TypePracticeData>, Array<ItemVM>>(
    `${__PRACTICE_API_URL__}/pratiche/tipo-pratica/`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: (response: AxiosResponse<HttpResponseList<TypePracticeData>>) => {
        const { data } = response;
        return data?.payload.list?.map((item) => ({
          id: item.key?.tipoPratica || '',
          value: `${item.key?.tipoPratica || ''}/${item?.descrizioneBreveTipoPratica || ''}`,
        }));
      },
    }
  );

  const dataList = (list.data as Array<ItemVM>) || [];

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} id="type-label">
        {required ? 'Tipo pratica *' : 'Tipo pratica'}
      </InputLabel>
      <PmiSelect
        labelId="type-label"
        id="type-practice"
        name="type-practice"
        value={value}
        label={required ? 'Tipo pratica *' : 'Tipo pratica'}
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {dataList?.map((type: ItemVM) => (
          <MenuItem key={type.id} value={type.id}>
            {type.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListTypePracticeComponent.displayName = 'List type component';

const ListTypePractice = memo(ListTypePracticeComponent);

export default ListTypePractice as typeof ListTypePracticeComponent;
